export default __webpack_public_path__ + "static/media/btcpay-directory-logo-white.d809a188.png";